export default class CoreTabs extends HTMLElement {
	constructor() {
		super();

		this.onButtonDown = this.onButtonDown.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
		this.onSelectChange = this.onSelectChange.bind(this);
		

	}

	connectedCallback() {
		this.$buttons = this.getScopedElements('[tab-button]');
 
		this.$selects = this.getScopedElements('[tab-select]');
		this.$slides = this.getScopedElements('[tab-slide]');
		this.updateQueryParam = this.getAttribute('query-param');

		if (!this.id) {
			this.id = `core-tabs-${Math.random().toString(36).slice(2, 8)}`;
		}

		const startIndex = this.hasAttribute('selected-index')
			? Number(this.getAttribute('selected-index'))
			: 0;

		if (this.$selects) {
			this.$selects.forEach((el, i) => {
				el?.addEventListener?.('change', this.onSelectChange);
			});
		}

		this.$buttons.forEach((el, i) => {
			const tabId = `${this.id}-tab-${i}`;
			const panelId = `${this.id}-panel-${i}`;

			el.setAttribute('role', 'tab');
			el.setAttribute('id', tabId);
			el.setAttribute('aria-controls', panelId);
			el.setAttribute('data-index', i);
			el.setAttribute('aria-selected', i === startIndex ? 'true' : 'false');
			el.setAttribute('tabindex', i === startIndex ? '0' : '-1');

			el.addEventListener('click', this.onButtonDown);
			el.addEventListener('keydown', this.onKeyDown);

			if (el.hasAttribute('tab-button-hover')) {
				el.addEventListener('mouseenter', this.onButtonDown);
			}
		});




		this.$slides.forEach((el, i) => {
			const tabId = `${this.id}-tab-${i}`;
			const panelId = `${this.id}-panel-${i}`;
			const isActive = i === startIndex;

			el.setAttribute('role', 'tabpanel');
			el.setAttribute('id', panelId);
			el.setAttribute('aria-labelledby', tabId);
			el.setAttribute('tabindex', isActive ? '0' : '-1');

			el.classList.toggle('is-active', isActive);
		});

		if (this.hasAttribute('use-intersection')) {
			let rendered = false;
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(async (entry) => {
					if (entry.isIntersecting && !rendered) {
						rendered = true;
						observer.disconnect();
						this.setActive(startIndex, false);
					}
				});
			}, {
				threshold: 0.15,
			});
			observer.observe(this);
		}
		else {
			this.setActive(startIndex, false);
		}

	}

	onSelectChange(e) {
		const index = Number(e.currentTarget.value);
		this.setActive(index, true);
	}

	disconnectedCallback() {
		this.$buttons?.forEach((el) => {
			el.removeEventListener('click', this.onButtonDown);
			el.removeEventListener('keydown', this.onKeyDown);
		});
	}

	getScopedElements(selector) {
		return Array.from(this.querySelectorAll(selector)).filter((el) => {
			return el.closest('core-tabs') === this;
		});
	}

	onButtonDown(e) {
		const index = Number(e.currentTarget.getAttribute('data-index'));
		this.setActive(index, true);
	}

	onKeyDown(e) {
		const currentIndex = this.$buttons.indexOf(e.currentTarget);

		if (currentIndex === -1) {
			return;
		}

		let newIndex = currentIndex;

		switch (e.key) {
			case 'ArrowLeft':
			case 'ArrowUp':
				newIndex = (currentIndex - 1 + this.$buttons.length) % this.$buttons.length;
				break;

			case 'ArrowRight':
			case 'ArrowDown':
				newIndex = (currentIndex + 1) % this.$buttons.length;
				break;

			case 'Home':
				newIndex = 0;
				break;

			case 'End':
				newIndex = this.$buttons.length - 1;
				break;

			default:
				return;
		}

		e.preventDefault();

		this.$buttons[newIndex].focus();
		this.setActive(newIndex, true);
	}

	setActive(index, updateQuery) {

		this.$buttons.forEach((btn, i) => {
			const isActive = i === index;
			btn.classList.toggle('is-active', isActive);
			btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
			btn.setAttribute('tabindex', isActive ? '0' : '-1');
		});

		this.$slides.forEach((panel, i) => {
			const isActive = i === index;
			panel.classList.toggle('is-active', isActive);
			panel.setAttribute('tabindex', isActive ? '0' : '-1');
			panel.toggleAttribute('inert', !isActive);
			
			if (!isActive) {
				panel.querySelectorAll('video, audio, core-video, core-audio, [autoplay-node]')?.forEach(el => {
					el?.pause?.();
				});
			}
			else {
				panel.querySelectorAll('[autoplay-node]')?.forEach(el => {
					el?.play?.();
				});
				console.log('SET_ACTIVE_TAB!', this);
			}

		});

		if (updateQuery && this.updateQueryParam) {
			const url = new URL(window.location);
			url.searchParams.set(this.updateQueryParam, index);
			window.history.pushState({}, '', url);
		}

	}
}

customElements.define('core-tabs', CoreTabs);